import React from 'react'
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap'
export default function Menu() {
    return (
        <div  >
            <Navbar bg="light" expand="lg">
                <Container fluid>
                    <Navbar.Brand href="/">OpenProfile</Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto">
                            <Nav.Link href="/">Home</Nav.Link>
                            <Nav.Link href="/private-profile">Profile</Nav.Link>
                            <Nav.Link href="/achievements">Achievements</Nav.Link>
                            <Nav.Link href="/logout">Logout</Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </ div>
    )
}
